import React from 'react';
import {
    Box,
    Paper,
    BottomNavigation,
    BottomNavigationAction
} from '@mui/material';
import Header from "./Header";
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

// Icons
import HomeIcon from '@mui/icons-material/Home';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PersonIcon from '@mui/icons-material/Person';
import BottomScrollableBar from "../components/BottomScrollableBar";
import GlobalDeliveredRating from "./GlobalDeliveredRating";

export default function Layout() {
    const navigate = useNavigate();
    const location = useLocation();

    const [isModalOpen, setIsModalOpen] = React.useState(false);

    React.useEffect(() => {
        const checkModal = () => {
            setIsModalOpen(document.body.classList.contains("modal-open"));
        };
        checkModal();
        window.addEventListener("modal-state-change", checkModal);
        return () => {
            window.removeEventListener("modal-state-change", checkModal);
        };
    }, []);

    const showBottomBar = ["/home", "/menu"].includes(location.pathname) && !isModalOpen;

    const getNavValue = () => {
        if (location.pathname === '/home') return 0;
        if (location.pathname === '/menu') return 1;
        if (location.pathname === '/orders') return 2;
        if (location.pathname === '/profile') return 3;
        return 0;
    };

    // Styling configuration for the navigation items to match the new design
    const navActionStyle = {
        minWidth: 'auto',
        borderRadius: '16px',
        m: 0.5,
        p: 1,
        transition: 'all 0.2s ease',
        '&.Mui-selected': {
            bgcolor: '#efe8dc9f', // 🎨 Theme: Primary Yellow Highlight
            color: '#fff7f2',
            '& .MuiBottomNavigationAction-label': {
                color: '#6D4C41',
                fontWeight: '800',
                fontSize: '0.75rem',
                mt: 0.5
            },
            '& .MuiSvgIcon-root': {
                color: '#56362b'
            }
        },
        '&:not(.Mui-selected)': {
            '& .MuiBottomNavigationAction-label': {
                color: '#6D4C41', // 🎨 Theme: Inactive text
                fontWeight: '600',
                fontSize: '0.75rem',
                mt: 0.5
            },
            '& .MuiSvgIcon-root': {
                color: '#6D4C41' // 🎨 Theme: Inactive icon
            }
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#FFFDF8' }}>
            <GlobalDeliveredRating />
            
            <Header />

            <Box sx={{ flex: 1, pb: '90px', display: 'flex', flexDirection: 'column' }}>
                <Outlet />
            </Box>

            {showBottomBar && (
                <BottomScrollableBar />
            )}

            <Paper
                elevation={0}
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    borderTopLeftRadius: 24,
                    borderTopRightRadius: 24,
                    overflow: 'hidden',
                    zIndex: 1000,
                    bgcolor: '#F8D548', // 🎨 Theme: Soft Cream Nav Background
                    boxShadow: '0 -4px 20px rgba(58, 44, 35, 0.05)',
                    borderTop: '2px solid #c3a16918'
                }}
            >
                <BottomNavigation
                    value={getNavValue()}
                    showLabels
                    sx={{
                        height: 75,
                        bgcolor: 'transparent',
                        px: 1,
                        alignItems: 'center'
                    }}
                >
                    <BottomNavigationAction label="Home" icon={<HomeIcon />} onClick={() => navigate('/home')} sx={navActionStyle} />
                    <BottomNavigationAction label="Menu" icon={<FastfoodIcon />} onClick={() => navigate('/menu')} sx={navActionStyle} />
                    <BottomNavigationAction label="Orders" icon={<ReceiptLongIcon />} onClick={() => navigate('/orders')} sx={navActionStyle} />
                    <BottomNavigationAction label="Account" icon={<PersonIcon />} onClick={() => navigate('/profile')} sx={navActionStyle} />
                </BottomNavigation>
            </Paper>
        </Box>
    );
}